import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { SabisNgxDialogService } from 'sabis-components2';
import { HiringRequestDialogData } from '../hiring-request-editor/hiring-request-editor.component';
import { ApprovalStepDTO } from '../models';
import { HiringRequestApprovalEditorComponent } from './hiring-request-approval-editor/hiring-request-approval-editor.component';

@Injectable({
  providedIn: 'root'
})
export class HiringRequestApprovalsService {

  constructor(@Inject('API_URL') private _apiUrl: string,
    private _dialogService: SabisNgxDialogService,
    private _http: HttpClient) { }

  public getApprovalHistory(hiringRequestId: number): Observable<ApprovalStepDTO[]> {
    let url: string = `${this._apiUrl}/admin/hiring-requests/${hiringRequestId}/approval-history`;

    return this._http.get<ApprovalStepDTO[]>(url);
  }

  public approveHiringRequest(hiringRequestId: number, data: HiringRequestApprovalCommandDTO | null): Observable<void> {
    let url: string = `${this._apiUrl}/admin/hiring-requests/${hiringRequestId}/approve`;

    return this._http.post<void>(url, data);
  }

  public rejectHiringRequest(hiringRequestId: number, data: HiringRequestApprovalCommandDTO): Observable<void> {
    let url: string = `${this._apiUrl}/admin/hiring-requests/${hiringRequestId}/reject`;

    return this._http.post<void>(url, data);
  }

  public openHirirngRequestApprovalDialog(hiringRequestId: number, approvalActionId: number): Observable<boolean> {
    let data: HiringRequestDialogData = {
      hiringRequestId: hiringRequestId,
      approvalActionId: approvalActionId,
    };
    var dialog = this._dialogService.open(HiringRequestApprovalEditorComponent, {
      data: data,
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }
}


export interface HiringRequestApprovalCommandDTO {
  rejectionReason?: string;
}
